(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ym-art-archive"] && !Shopify.designMode) return;
  try {
    
function setupYmPalmNotes(root) {
  root.querySelectorAll('.ym-palm-notes-browser').forEach(browser => {
    if (browser.dataset.ymReady) return;
    browser.dataset.ymReady = 'true';
    browser.querySelectorAll('[data-ym-note-filter]').forEach(button => {
      button.addEventListener('click', () => {
        const category = button.dataset.ymNoteFilter;
        browser.querySelectorAll('[data-ym-note-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        browser.querySelectorAll('[data-ym-note-category]').forEach(note => {
          note.hidden = category !== 'all' && note.dataset.ymNoteCategory !== category;
        });
      });
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupYmPalmNotes(document));
else setupYmPalmNotes(document);
document.addEventListener('shopify:section:load', event => setupYmPalmNotes(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ym-featured-wall"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    if (root.dataset.ymInitialized) return;
    root.dataset.ymInitialized = 'true';
    const grid = root.querySelector('ul.product-grid');
    const pager = root.querySelector('[data-ym-pager]');
    const link = root.querySelector('[data-ym-next]');
    if (!grid || !pager || !link) return;
    const label = link.textContent;
    const status = root.querySelector('[data-ym-status]');
    const seen = new Set(Array.from(grid.querySelectorAll('[data-ym-product]'), card => card.dataset.ymProduct));
    const limit = 324;
    let busy = false;
    let automatic = true;
    let observer;
    async function loadMore() {
      if (busy || pager.hidden || seen.size >= limit) return;
      busy = true;
      link.setAttribute('aria-disabled', 'true');
      grid.setAttribute('aria-busy', 'true');
      link.textContent = link.dataset.loading;
      status.textContent = link.dataset.loading;
      if (observer) observer.unobserve(pager);
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const url = new URL(link.href, window.location.origin);
        const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        url.searchParams.set('section_id', root.dataset.ymWall);
        const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw new Error('section unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = doc.querySelector('[data-ym-wall]');
        if (!incoming) throw new Error('section missing');
        const fragment = document.createDocumentFragment();
        let added = 0;
        incoming.querySelectorAll('ul.product-grid > [data-ym-product]').forEach(card => {
          if (seen.size >= limit || seen.has(card.dataset.ymProduct)) return;
          seen.add(card.dataset.ymProduct);
          card.classList.remove('scroll-trigger', 'animate--slide-in');
          card.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; img.decoding = 'async'; });
          card.querySelectorAll('script, link[rel="stylesheet"]').forEach(node => node.remove());
          fragment.appendChild(card);
          added++;
        });
        if (!added) throw new Error('no new products');
        grid.appendChild(fragment);
        const next = incoming.querySelector('[data-ym-next]');
        if (!next || seen.size >= limit) {
          pager.hidden = true;
          if (observer) observer.disconnect();
        } else {
          link.href = next.getAttribute('href');
        }
        link.textContent = label;
        status.textContent = '';
      } catch (error) {
        automatic = false;
        link.textContent = link.dataset.retry;
        status.textContent = link.dataset.retry;
      } finally {
        clearTimeout(timeout);
        busy = false;
        link.removeAttribute('aria-disabled');
        grid.removeAttribute('aria-busy');
        if (observer && automatic && !pager.hidden) observer.observe(pager);
      }
    }
    link.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      loadMore();
    });
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        if (automatic && entries.some(entry => entry.isIntersecting)) loadMore();
      }, { rootMargin: '600px 0px' });
      observer.observe(pager);
    }
  }
  function boot() { document.querySelectorAll('[data-ym-wall]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
